import { connect } from "react-redux";
import { compose } from "redux";
import LandingHeaderController from "./header-controller";
import { getValue } from "store/languages";
import { setMenuActive, setIsShowMobileMenu, setIsShowDemo} from "store/landing";
import {setSelectedLanguage} from "store/languages";
import { setAuthLanguage } from "store/authorization";

let mapStateToProps = (state) => {

    return {
        LanguageItems: state.LandingMenu.LanguageItems,
        selectedLanguage: state.languages.selectedLanguage,
        menu: state.LandingMenu.menuItems,
        activeMenu: state.LandingMenu.activeMenu,
        isShowMobileMenu: state.LandingMenu.isShowMobileMenu
    }
}

const LandingHeaderContainer = compose(connect(mapStateToProps, {
    getValue,
    setMenuActive,
    setSelectedLanguage,
    setIsShowMobileMenu,
    setIsShowDemo,
    setAuthLanguage
}))(LandingHeaderController);

export default LandingHeaderContainer;